<template>
  <el-table-column v-if="!col.hidden&&col.rownumber"
                   :label="col.title"
                   type="index"
                   width="50">
  </el-table-column>
  <el-table-column v-else-if="!col.hidden&&col.checkbox" type="selection"></el-table-column>
  <el-table-column v-else-if="!col.hidden&&col.rowexpand" type="expand">
    <!--自定义内容-->
    <div v-if="col.expand" v-html="col.expand()"></div>
    <!--行显示-->
    <el-form v-else-if="col.items" label-position="left" inline class="demo-table-expand">
      <el-form-item :label="item.label?item.label:col.title" :key="idx" v-for="(item,idx) in col.items">
        <span v-text="item.value"></span>
      </el-form-item>
    </el-form>
  </el-table-column>
  <el-table-column
    v-else-if="!col.hidden&&col.buttons"
    :fixed="col.fixed"
    :field="col.field" :label="col.title"
    :[widthname]="col.width"
    :align="col.align||'center'" :header-align="col.align||'center'">
    <template slot-scope="scope">
      <template v-for="(btn,i) in col.buttons">
        <el-button style="margin-bottom:5px" v-if="btn.show?btn.show.call(scope._self,scope.$index,scope.row):true" :key="i"
                   @click="btn.handler.call(scope._self,scope.$index,scope.row)"
                   :type="btn.type"
                   size="small"
                   v-text="isFunction(btn.text) ? btn.text.call(scope._self, scope.$index, scope.row) : btn.text"
        >
        </el-button>
        <slot v-if="col.br"><br/></slot>
      </template>

    </template>
  </el-table-column>
  <el-table-column
    v-else-if="!col.hidden&&col.items"
    :fixed="col.fixed"
    :field="col.field" :label="col.title"
    :[widthname]="col.width"
    :class-name="col.class" :align="col.align||'center'" :header-align="col.align||'center'">
    <template slot-scope="scope">
      <template v-for="(item,i) in col.items">
        <slot v-if="item.handler">
          <el-button
            :key="i"
            v-if="item.show?item.show.call(scope._self,scope.$index,scope.row):true"
            @click="item.handler.call(scope._self,scope.$index,scope.row,scope,col)"
            :type="item.type"
            size="small"
          >{{ isFunction(item.text) ? item.text.call(scope._self, scope.$index, scope.row) : item.text }}


          </el-button>
        </slot>
        <slot v-else-if="item.br">
          <br>
        </slot>
        <slot v-else-if="item.uploader">
          <my-upload
            v-if="item.show?item.show.call(scope._self,scope.$index,scope.row):true"
            :key="i"
            :showtips="false" :btntext="item.text" uploadtype="fileurl" :acceptfiles="item.acceptfiles"
            @uploadsuccess="item.uploader($event,scope.row,scope.column,scope.$index ,scope.store,scope._self)"></my-upload>
        </slot>
        <slot v-else-if="item.render">
          <div :key="i" v-if="item.show?item.show.call(scope._self,scope.$index,scope.row):true"
               v-html="item.render(scope.row,scope.column,scope.$index ,scope.store,scope._self)"></div>
        </slot>
        <slot v-else-if="item.imglist">
          <div v-if="item.show?item.show.call(scope._self,scope.$index,scope.row):true">
            <el-card :body-style="imglistbodystyle">
              <img v-if="getPath(img,item.imglist)" :style="{marginLeft:i!=0?'5px':''}" v-for="(img,i) in makeArray(scope.row[item.field])" :key="i"
                   @click="item.showPic?item.showPic(img,item.imglist.path):showPic(img,item.imglist.path)" :src="getPath(img,item.imglist)"
                   alt="">
            </el-card>
          </div>
        </slot>
        <slot v-else>{{ scope.row[col.field] }}</slot>
      </template>
    </template>
  </el-table-column>
  <el-table-column cellpiclist v-else-if="!col.hidden&&col.imglist" :filters="col.filters" :filter-method="col.filterHandler" :sortable="col.sort"
                   :fixed="col.fixed" :prop="col.field" :field="col.field" :label="col.title"
                   :[widthname]="col.minwidth||col.width" align="center" header-align="left">
    <template slot-scope="props">
      <el-card :body-style="imglistbodystyle">
        <img :style="{marginLeft:i!=0?'5px':''}" v-for="(img,i) in makeArray(props.row[col.field])" :key="i" v-if="getPath(img,col.imglist)"
             @click="col.showPic?col.showPic(img,col.imglist.path):showPic(img,col.imglist.path)" :src="getPath(img,col.imglist)" alt="">
      </el-card>
    </template>
  </el-table-column>
  <el-table-column v-else-if="!col.hidden" :filters="col.filters" :filter-method="col.filterHandler" :sortable="col.sort"
                   :fixed="col.fixed" :prop="col.field" :field="col.field" :label="col.title"
                   :[widthname]="col.minwidth||col.width" :align="col.align||'center'" :header-align="col.align||'center'"
  >
    <template slot-scope="scope">
      <slot v-if="col.render">
        <div v-html="col.render(scope.row,scope.column,scope.$index ,scope.store,scope._self)"></div>
      </slot>
      <slot v-else-if="col.toggle">
        <el-button v-if="col.show?col.show(scope.row,col):true" type="primary" size="small" plain :style="col.getStyle(scope,col)" @click="col.onToggle.call(scope._self,scope,col)"
                   v-text="col.getText(scope,col)"></el-button>
      </slot>
      <slot v-else-if="col.model">
        {{ '{1}{2}{3}'.eformat(col.pretext, getFieldVal(scope.row, col.model), col.apptext) }}
      </slot>
      <slot v-else-if="col.convert">
        {{ '{1}{2}{3}'.eformat(col.pretext, getFieldVal(col.convert.obj, getFieldVal(scope.row, col.convert.path || col.field), col.convert.def || ''), col.apptext) }}
      </slot>
      <slot v-else>{{ '{1}{2}{3}'.eformat(col.pretext, scope.row[col.field], col.apptext) }}</slot>
    </template>
    <template v-if="col.children">
      <my-column v-for="(item, index) in col.children" :key="index" :col="item"></my-column>
    </template>
  </el-table-column>
</template>
<script>
import Vue from "vue";
import MyUpload from './MyUpload'

export default {
  name: 'MyColumn',
  props: ['col', 'cols', 'scope', 'props', 'fromvue'],
  data() {
    return {
      imglistbodystyle: {
//          textAlign: 'center'
      }
    };
  },
  methods: {
    showPic(img, path) {
      var url = path ? this.getFieldVal(img, path) : img;
      if (this.fromvue) {
        this.getVue(this.fromvue).showPicDialog(url);
      }
      this.$emit('showpic', url);
    },
    getPath(item, cfg) {
      return cfg.path ? this.getFieldVal(item, cfg.path) : item;
    },
    getWidth(col) {

    }
  },
  computed: {
    // 计算属性的 getter
    widthname: function () {
      // `this` 指向 vm 实例
      return this.col.flex ? 'min-width' : 'width';
    }
  }
}
</script>
<style>
.el-table__row .cell .el-card.is-always-shadow {
  width: fit-content;
  height: fit-content;
}

.el-table__row .cell .el-button + .el-button {
  margin-top: 5px;
  margin-bottom: 5px;
}

.el-table__row .cell .el-upload-list__item.is-success {
  display: none;
}

.el-table__row .cell .el-card.is-always-shadow .el-card__body {
  padding: 0;
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MyColumn.vue